import BrokersApi from '../BrokersApi';
import * as types from './ActionTypes';
import IBrokerAgent from '../agent/IBrokerAgent';
import IBrokerListAgent from '../list/IBrokerListAgent';
import ICreatedAgentActivation from '../agent/ICreatedAgentActivation';
import IPasswordLinkResult from '../agent/IPasswordLinkResult';

type ICreatedBrokerAgent = IBrokerAgent & ICreatedAgentActivation;
type ICreatedBrokerListAgent = IBrokerListAgent & ICreatedAgentActivation;

function withoutPasswordLink<T extends ICreatedAgentActivation>(result: T): T {
    if (!result || !result.passwordLink) {
        return result;
    }

    let forStore = { ...(result as any) };
    delete forStore.passwordLink;

    return forStore;
}

function newBrokerAgentSuccess(result: any) {
    return { type: types.NEW_BROKER_AGENT_SUCCESS, result };
}

export function newBrokerAgent(id: number) {
    return (dispatch: (result: any) => void) =>
        BrokersApi.newBrokerAgent(id).then((result: any) => {
            dispatch(newBrokerAgentSuccess(result));
        });
}

function createBrokerAgentSuccess(result: IBrokerAgent) {
    return { type: types.CREATE_BROKER_AGENT_SUCCESS, result };
}

export function createBrokerAgent(data: any) {
    return (dispatch: (result: any) => void) =>
        BrokersApi.createBrokerAgent(data).then((result: ICreatedBrokerAgent) => {
            dispatch(createBrokerAgentSuccess(withoutPasswordLink(result)));

            return result;
        });
}

function editBrokerAgentSuccess(result: any) {
    return { type: types.EDIT_BROKER_AGENT_SUCCESS, result };
}

export function editBrokerAgent(id: number) {
    return (dispatch: (result: any) => void) =>
        BrokersApi.editBrokerAgent(id).then((result: any) => {
            dispatch(editBrokerAgentSuccess(result));
        });
}

function updateBrokerAgentSuccess(result: IBrokerAgent) {
    return { type: types.UPDATE_BROKER_AGENT_SUCCESS, result };
}

export function updateBrokerAgent(id: number, data: any) {
    return (dispatch: (result: any) => void) =>
        BrokersApi.updateBrokerAgent(id, data).then((result: IBrokerAgent) => {
            dispatch(updateBrokerAgentSuccess(result));
        });
}

function createBrokerListAgentSuccess(result: IBrokerListAgent) {
    return { type: types.CREATE_BROKER_LIST_AGENT_SUCCESS, result };
}

export function createBrokerListAgent(data: any) {
    return (dispatch: (result: any) => void, getState: any) =>
        BrokersApi.createListBrokerAgent(data).then((result: ICreatedBrokerListAgent) => {
            dispatch(createBrokerListAgentSuccess(withoutPasswordLink(result)));

            return result;
        });
}

function updateBrokerListAgentSuccess(result: IBrokerListAgent) {
    return { type: types.UPDATE_BROKER_LIST_AGENT_SUCCESS, result };
}

export function updateBrokerListAgent(id: number, data: any) {
    return (dispatch: (result: any) => void, getState: any) =>
        BrokersApi.updateListBrokerAgent(id, data).then((result: IBrokerListAgent) => {
            dispatch(updateBrokerListAgentSuccess(result));
        });
}

export function sendAgentPasswordLink(id: number, sendMail: boolean) {
    return () =>
        BrokersApi.sendAgentPasswordLink(id, sendMail).then((result: IPasswordLinkResult) => result);
}
